import React from "react";


const Titles = () => {
  const currentUrl = window.location.href;
  let locationType = "washington"; // Default washington state

  if (currentUrl.includes("local.navysealsmoving")) {
    locationType = "local";
  } else if (currentUrl.includes("oregon.navysealsmoving")) {
    locationType = "oregon";
  } else if (currentUrl.includes("nynj.navysealsmoving")) {
    locationType = "nynj";
  } else if (currentUrl.includes("nc.navysealsmoving")) {
    locationType = "nc";
  }

  return (

	<section
    className="titles" id="hero" >
	    <div className="container">
			<div className="row">
				<div className="col-md-12 col-sm-12 titles_sec">
					<div className="hero-flex">
					<div className="hero-text-block">
					{/* Heading */}
					<div className="hero-heading-row">
						<div>
						{locationType === "local" && (
							<h1>Your Trusted Specialists for Local and Long-Distance Moving</h1>
						)}
						{locationType === "washington" && (
							<>
							<h1>Your Trusted Long Distance Movers</h1>
							<h2>Nationwide Moving from Washington State to any destination</h2>
							</>
						)}
						{locationType === "oregon" && (
							<>
							<h1>Your Trusted Long Distance Movers</h1>
							<h2>Nationwide Moving from Oregon to any destination</h2>
							</>
						)}
						{locationType === "nynj" && (
							<>
							<h1>Your Trusted Long Distance Movers</h1>
							<h2>Nationwide Moving from New York and New Jersey to any destination</h2>
							</>
						)}
						{locationType === "nc" && (
							<>
							<h1>Your Trusted Long Distance Movers</h1>
							<h2>Nationwide Moving from North Carolina to any destination</h2>
							</>
						)}
						</div>
					</div>
					{/* End: Heading */}

					{/* Trust signals */}
					<div className="hero-cta-row">
						<ul className="hero-trust-list">
							<li>Family-Owned &middot; 20+ Years &middot; Nearly 3,000 Moves a Year</li>
							<li>Guaranteed Price After a Free Video Walkthrough</li>
							<li>Elite Crews &middot; State-of-the-Art Equipment &middot; Never a Broker</li>
							<li>Google Guaranteed &middot; Licensed, Bonded &amp; Insured</li>
							<li>Impeccable Quality: a Perfect 5.0 on Google</li>
						</ul>
					</div>
					{/* End: Trust signals */}
					</div>

					{/* Google reviews badge (all versions) */}
					<div className="hero-badge">
						<a target="_blank" rel="noopener noreferrer" href="https://goo.gl/maps/cUrKYLa1WfEjfajX8">
							<img decoding="async" src="/assets/images/google-tag.webp"
								width="150" title="google_badge" alt="Navy Seals Moving 5-star Google reviews" />
						</a>
					</div>
					</div>
				</div>
			</div>
        </div>
	</section>

  );
};

export default Titles;
